:host {
    display: inline-block;

    ti-input {
        width: 100%;
    }

    .ti-add-to-cart-btn-container {
        display: flex;

        ti-button {
            width: 100%;
            flex-grow: 1;
        }

        ti-button.ti-button-disabled {
            pointer-events: none; //Disable any clicks
        }

        // Add to list button
        ti-add-to-myti-list {
            margin-left: $polaris-space-1;
        }
    }

    .ti-add-to-cart-list-btn-container-phone {
        margin-top: $polaris-space-2;
    }

    //Custom Reel message
    .ti-add-to-cart-custom-reel {
        margin-top: $polaris-space-2;
        font-size: $polaris-font-size-2;

        &.ti-add-to-cart-custom-reel-cnjp { // CN & JP 14px
            font-size: $polaris-font-size-2;
        }
    }

    //Sku message
    .ti-add-to-cart-sku-selection {
        margin-top: $polaris-space-1;
        font-size: $polaris-font-size-2;

        &.ti-add-to-cart-sku-selection-cnjp { // CN & JP 14px
            font-size: $polaris-font-size-2;
        }
    }
}

:host(.ti-add-to-cart-inline) {
    display: flex;
    flex-wrap: wrap;

    & > ti-form-element {
        flex: 1 1 1px;
        margin-right: 0.5rem;

        ti-input {
            display: block;
        }
    }

    & > ti-button {
        width: auto;
    }

    .ti-add-to-cart-message {
        flex-basis: 100%;
    }
}

:host(.ti-add-to-cart-inline:not([compact-button])) {
    --pl-input-height: 40px;
}
